module.exports = __webpack_public_path__ + "static/media/mutlilingue-saphir.2cd2ebe9.png";